import { connect } from 'react-redux';
import SearchSummary from './SearchSummary';
import { formatSummary } from '../../utils/search-utils';

const mapState = (state, props) => {
  const { fenderConnect, search } = state;
  const { hasSubscription } = fenderConnect;
  const { instantResults } = search || {};
  const results = instantResults;
  const { facets, hits, query } = results || {};
  return {
    ...props,
    query,
    summaryArr: formatSummary(hits, facets, query, hasSubscription),
    hasSubscription,
  };
};

export default connect(mapState)(SearchSummary);
